export default __webpack_public_path__ + "static/media/goal.97a87075.svg";